<div class="main-container mt-lg-3">
  <div class="inner-container overflow-y px-3 pb-4" *ngIf="loaded && shipmentInfo">
    <app-title-with-languages [title]="viewTitle"></app-title-with-languages>
    <div class="dm-container">
      <div class="d-flex flex-column flex-lg-row justify-content-between mt-3">
        <button class="btn btn-primary btn-50-mobile w-100 lg-30 mb-3" (click)="downloadTicket()">
          <i class="bi bi-file-earmark-arrow-down me-2"></i>{{ "VIEW_DOWNLOAD_TICKET" | translate }}
        </button>
        <button class="btn btn-primary btn-50-mobile w-100 lg-30 mb-3" (click)="goToEditShipment()"><i class="bi bi-pencil me-2"></i>{{ "EDIT_TITLE" | translate }}</button>
        <button class="btn btn-primary btn-50-mobile w-100 lg-30 mb-3" (click)="backToMyBookings()">
          <i class="bi bi-card-list me-2"></i>{{ "SHIPMENT_LIST_TITLE" | translate }}
        </button>
      </div>

      <div [innerHTML]="ticketString | safeHtml"></div>

      <div class="mb-3">
        <div *ngFor="let a of shipmentInfo.attachments1" class="d-flex flex-row chip justify-content-between">
          <div class="chip-icon-left"><i class="bi bi-paperclip"></i></div>
          <label class="chip-label flex-grow-1">{{ a.originalName }}</label>
          <div class="chip-icon-right" (click)="downloadAttachment(a)"><i class="bi bi-file-earmark-arrow-down-fill"></i></div>
        </div>
        <div *ngFor="let a of shipmentInfo.attachments2" class="d-flex flex-row chip justify-content-between">
          <div class="chip-icon-left"><i class="bi bi-paperclip"></i></div>
          <label class="chip-label flex-grow-1">{{ a.originalName }}</label>
          <div class="chip-icon-right" (click)="downloadAttachment(a)"><i class="bi bi-file-earmark-arrow-down-fill"></i></div>
        </div>
        <div *ngFor="let a of shipmentInfo.attachments3" class="d-flex flex-row chip justify-content-between">
          <div class="chip-icon-left"><i class="bi bi-paperclip"></i></div>
          <label class="chip-label flex-grow-1">{{ a.originalName }}</label>
          <div class="chip-icon-right" (click)="downloadAttachment(a)"><i class="bi bi-file-earmark-arrow-down-fill"></i></div>
        </div>
      </div>
    </div>
  </div>
  <div class="inner-container overflow-y px-3 pb-4 mt-3" *ngIf="!loaded">
    <div class="d-flex flex-column align-items-center">
      <div class="spinner-border mb-3" style="width: 4rem; height: 4rem" role="status"></div>
      {{ "LOADING_DATA" | translate }}
    </div>
  </div>
</div>
